//import { fetchListData } from '../api/api'

import Vue from 'vue';
import router from '../router';

export default {

  logout ({commit}) {
    commit('logout')
    localStorage.removeItem('token')
  },
  api_error ({ commit }, error) {
    console.log("api_error", error)
    if (Vue.config.productionTip) {
      commit('logout')
      router.push({ name: 'login' })
    }
  },

  initDarkMode({ commit }) {
    const saved = localStorage.getItem('darkMode');
    if (saved !== null) {
      commit('SET_DARK_MODE', saved === 'true');
      return;
    }
    if (window.matchMedia && window.matchMedia('(prefers-color-scheme: dark)').matches) {
      commit('SET_DARK_MODE', true);
    }
  },

  setDarkMode({ commit }, value) {
    commit('SET_DARK_MODE', value);
    localStorage.setItem('darkMode', value.toString());
  },
}
